/* global elementorFrontend, jQuery */
(function () {
    function getCategoryLabels() {
        return (window.carouselCtaCategories && window.carouselCtaCategories.labels) || [];
    }

    function getCategoryUrls() {
        return (window.carouselCtaCategories && window.carouselCtaCategories.urls) || [];
    }

    function initCarouselButtons() {
        document.querySelectorAll('.carousel-cta-wrapper').forEach(function (wrapper) {
            var swiperEl = wrapper.querySelector('.elementor-image-carousel-wrapper');
            var prevBtn = wrapper.querySelector('.carousel-cta-prev');
            var nextBtn = wrapper.querySelector('.carousel-cta-next');
            var ctaBtn = wrapper.querySelector('.carousel-cta-button');
            var ctaText = ctaBtn ? ctaBtn.querySelector('.carousel-cta-button-text') : null;

            if (!swiperEl) return;

            function getSwiper() {
                return swiperEl.swiper || (window.jQuery && jQuery(swiperEl).data('swiper'));
            }

            function updateDisabledState() {
                var sw = getSwiper();
                if (!sw) return;
                if (prevBtn) prevBtn.classList.toggle('is-disabled', sw.isBeginning);
                if (nextBtn) nextBtn.classList.toggle('is-disabled', sw.isEnd);
            }

            function updateCtaText() {
                var sw = getSwiper();
                if (!sw) return;

                var labels = getCategoryLabels();
                var urls = getCategoryUrls();
                var label = labels[sw.activeIndex];
                var url = urls[sw.activeIndex];

                if (ctaText && label) {
                    ctaText.textContent = label;
                }
                if (ctaBtn && url) {
                    ctaBtn.setAttribute('href', url);
                }
            }

            function updateAll() {
                updateDisabledState();
                updateCtaText();
            }

            if (prevBtn && !prevBtn.dataset.bound) {
                prevBtn.dataset.bound = "true";
                prevBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    var sw = getSwiper();
                    if (sw && !sw.isBeginning) sw.slidePrev();
                });
            }
            if (nextBtn && !nextBtn.dataset.bound) {
                nextBtn.dataset.bound = "true";
                nextBtn.addEventListener('click', function (e) {
                    e.preventDefault();
                    var sw = getSwiper();
                    if (sw && !sw.isEnd) sw.slideNext();
                });
            }

            var sw = getSwiper();

            if (!sw) {
                setTimeout(function () {
                    initCarouselButtons();
                }, 200);
                return;
            }

            if (!sw._ctaBound) {
                sw._ctaBound = true;
                sw.on('slideChange', updateAll);
                sw.on('reachBeginning', updateAll);
                sw.on('reachEnd', updateAll);
                sw.on('fromEdge', updateAll);
            }

            updateAll();
        });
    }

    function ready(fn) {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            fn();
        } else {
            document.addEventListener('DOMContentLoaded', fn);
        }
    }

    ready(function () {
        setTimeout(initCarouselButtons, 300);
    });

    window.addEventListener('elementor/frontend/init', function () {
        if (window.elementorFrontend && elementorFrontend.hooks) {
            elementorFrontend.hooks.addAction('frontend/element_ready/image-carousel.default', function () {
                setTimeout(initCarouselButtons, 300);
            });
        }
    });
})();